import { render } from "./Sv006.vue?vue&type=template&id=450b004c&scoped=true"
import script from "./Sv006.vue?vue&type=script&lang=js"
export * from "./Sv006.vue?vue&type=script&lang=js"

import "./Sv006.vue?vue&type=style&index=0&id=450b004c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450b004c"]])

export default __exports__